import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  toggleInstalled(event) {
    this.toggleTargets.forEach(toggle => {
      toggle.disabled = !event.target.checked
      toggle.previousElementSibling.disabled = !event.target.checked
      toggle.checked = event.target.checked
      toggle.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
